export const userId = (() => {
  try {
    const user = localStorage.getItem("user");
    if (user) {
      const parsed = JSON.parse(user);
      return parsed.id || parsed.uuid;
    }
  } catch (e) {
    console.error("Error parsing user from localStorage", e);
  }
  return "user1";
})();
